module.exports = __webpack_public_path__ + "img/panicButton.6409b92d.webp";